import getServiceLineLink from '@/utils/getServiceLineLink'

/**
  開啟智生活 LINE 官方帳號
  一律使用 https universal link：有裝 LINE 會喚起 App，沒裝則落回 line.me 網頁，
  不會像 line:// scheme 一樣沒反應或開出無效網址
  @param {boolean} isApp 是否在 App 內開瀏覽器
  @param {number|string} [serviceId] 服務 ID，用於取得對應官方帳號
*/
export const openLineLink = (isApp, serviceId) => {
  const lineLink = getServiceLineLink(serviceId)
  if (isApp) {
    // 藉由廣告架構，利用 app 的預設瀏覽器開啟，universal link 才能喚起 LINE App
    window.location.href = `${process.env.IN_APP_AD_URL}?page=thirdPartyLink&params1=${lineLink}&referrer=`
  } else {
    window.open(lineLink, '_blank')
  }
}

export default openLineLink
